import React, { FC, memo, useCallback, useEffect, useMemo, useState } from 'react';

import { RequiredRule } from 'devextreme-react/form';

import { AppFieldBox } from 'components/appComponents';
import { useAuth } from 'context/auth';
import { ContextMenu, SelectBox, Validator } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import { ContractorIndividualAddModal, ContractorLegalEditAddModal } from 'pages/Contractor';

import { useLazyGetContractorObjectGroupsQuery } from 'bus/contractorObject/services';

//import { Button } from "devextreme-react/select-box";

export type ContractorChangeType = {
  contractorType: number | null;
  contractorId: number;
  objectId: null;
};

type CustomerTaskProps = {
  value: number | null;
  readOnly: boolean;
  onChange: (value: ContractorChangeType) => void;
  storeCustomer: DataSource;
};

const CustomerTask: FC<CustomerTaskProps> = ({ value, readOnly, storeCustomer, onChange }) => {
  const { getClaims }: any = useAuth();

  const [getContractorObjectGroups] = useLazyGetContractorObjectGroupsQuery();

  const [visibleIndividual, setVisibleIndividual] = useState<boolean>(false);
  const [visibleLegal, setVisibleLegal] = useState<boolean>(false);
  const [menuVisible, setMenuVisible] = useState<boolean>(false);

  useEffect(() => {
    storeCustomer.load();
  }, [storeCustomer]);

  const getAddListContragetCreate = useCallback(() => {
    const claimsRoot = [
      {
        id: 'individual',
        text: 'Физ. лицо',
        claims: 'CanCreateIndividualContractor',
      },
      { id: 'legal', text: 'Юр. лицо', claims: 'CanCreateLegalContractor' },
    ];

    // eslint-disable-next-line array-callback-return
    return claimsRoot.filter((item) => {
      if (getClaims([item.claims])) return item;
    });
  }, [getClaims]);

  useEffect(() => {
    if (value) getContractorObjectGroups({ contractorId: value });
  }, [getContractorObjectGroups, value]);

  const refresh = () => storeCustomer.load();

  const handleChange = useCallback(
    (e) => {
      if (e.value && e.value.id) {
        onChange({
          contractorId: e.value.id,
          objectId: null,
          contractorType: e.value.contractorType,
        });
      }
    },
    [onChange],
  );

  const handleItemClick = useCallback((e) => {
    //@ts-ignore
    if (e.itemData.id === 'individual') setVisibleIndividual(true);
    //@ts-ignore
    if (e.itemData.id === 'legal') setVisibleLegal(true);
    setMenuVisible(false);
  }, []);

  const buttons = useMemo(() => {
    return [
      'dropDown',
      {
        name: 'customButtonName1',
        location: 'after',
        options: {
          elementAttr: {
            id: 'image',
          },
          onClick: () => setMenuVisible(!menuVisible),
          icon: 'plus',
          visible: !!getAddListContragetCreate().length,
        },
      },
    ];
  }, [getAddListContragetCreate, menuVisible]);

  const searchExpr = useMemo(() => ['name', 'inn'], []);

  return (
    <>
      {visibleLegal && (
        <ContractorLegalEditAddModal
          visible={visibleLegal}
          changeVisible={(show) => setVisibleLegal(show)}
          id={null}
          refresh={refresh}
        />
      )}

      {visibleIndividual && (
        <ContractorIndividualAddModal
          visible={visibleIndividual}
          changeVisible={(show) => setVisibleIndividual(show)}
          id={null}
          refresh={refresh}
        />
      )}

      <AppFieldBox label="Заказчик*" labelTop>
        <div className="d-flex align-center">
          <SelectBox
            stylingMode="underlined"
            style={{ width: '100%' }}
            readOnly={readOnly}
            placeholder="Выберите заказчика"
            mode="text"
            value={value}
            onValueChanged={handleChange}
            searchMode="contains"
            searchExpr={searchExpr}
            searchEnabled
            displayExpr="name"
            dataSource={storeCustomer}
            //@ts-ignore
            buttons={buttons}
          >
            <Validator>
              <RequiredRule message="Выберите заказчика" />
            </Validator>
          </SelectBox>

          <ContextMenu
            dataSource={getAddListContragetCreate()}
            width={200}
            target="#image"
            visible={menuVisible}
            onItemClick={handleItemClick}
            //closeOnOutsideClick={() => true}
            onVisibleChange={setMenuVisible}
          />
        </div>
      </AppFieldBox>
    </>
  );
};

export default memo(CustomerTask, (prevProps, nextProps) => {
  if (prevProps.value === nextProps.value && prevProps.onChange === nextProps.onChange) {
    return true;
  } else {
    return false;
  }
});
